export * from './social-medias';
export * from './social.component';
